// @ts-nocheck
import type { ResultItem, SearchResult } from '../../@types';
export const START_TIME = 1560945600000;
export function getResults(): SearchResult {
	const mockResults: ResultItem[] = [];
	const MAX_RESULTS = 20;

	for (let i = 0; i < MAX_RESULTS; ++i) {
		const result = {
			id: 'test',
			assetType: 'image',
			attributes: {
				name: `file-${i}`,
				modificationDate: START_TIME + i * 60000,
				fileSize: i,
			},
		};
		mockResults.push(result);
	}

	return {
		resultItems: mockResults,
	};
}
